<svelte:options accessors />

<script context="module" lang="ts">
	import { activeElement } from '$lib/client/store';
	//import env
	import { PUBLIC_ADDRESS_SERVICE_DOMAIN } from '$env/static/public';
	export let count = 0;

	export interface IAddress {
		_str: string;
		needNumber: boolean;
		unit_type?: string;
		is_secondary: boolean;
		street: any;
		city: any;
		state: any;
		zipcode: any;
		entries: any;
		type: 'google' | 'smarty';
		is_po_box: boolean;
		google_place_id?: string;
	}
	function buildAddress(suggestion: any): IAddress {
		let streetStr = suggestion.street_line;
		let streetStr2 = suggestion.street_line;
		let _needNumber = false;
		let secondaryHTML = ''; //If there is secondary information add text that is aligned to the right that says '+ xx Addresses >'
		//fontawesome '>' icon
		let secondaryIcon = 'fa-chevron-right';
		if (suggestion.secondary) {
			suggestion.unit_type = suggestion.secondary;
			streetStr2 += ' ' + suggestion.secondary + ' ';
			if (suggestion.entries > 1) {
				_needNumber = true;
				suggestion.secondary += ' (' + suggestion.entries + ' entries)';
			}
			streetStr += ' ' + suggestion.secondary;
			//secondaryHTML = `<span style="display: block;text-align: right;width: 100%;color: lightskyblue !important;">+ ${suggestion.entries} addresses <div class="fa ${secondaryIcon}"></div></span>`;
			//secondaryHTML = `+ ${suggestion.entries} + addresses
		}
		let _str =
			//'<span>' +
			streetStr +
			' ' +
			suggestion.city +
			', ' +
			suggestion.state +
			' ' +
			suggestion.zipcode +
			//'</span>' +
			secondaryHTML;
		// if (suggestion.country) {
		// 	_str += ', ' + suggestion.country;
		// }
		if (suggestion.data_source == 'google') {
			_str = suggestion.street_line;
		}
		let data: IAddress = {
			_str,
			needNumber: _needNumber,
			unit_type: suggestion.unit_type,
			is_secondary: suggestion.is_secondary,
			street: streetStr2,
			city: suggestion.city,
			state: suggestion.state,
			zipcode: suggestion.zipcode,
			entries: suggestion.entries,
			type: suggestion.data_source,
			is_po_box: suggestion.is_po_box,
			google_place_id: suggestion.google_place_id
		};
		return data;
	}
</script>

<script lang="ts">
	export const InstanceID = count;
	count += 1;
	import FormGroup from '../sub_components/FormGroup.svelte';
	import Address2 from './Address2.svelte';

	import { showLoadingBackdrop } from '$lib/client/store';
	import { Event } from '$lib/event';
	import { onDestroy, onMount, tick } from 'svelte';
	import type { Address2Config } from '$lib/config';
	import * as Store from '$lib/client/store';
	import { REST } from '$lib/client/conn';
	import 'highlight.js/styles/github.css';
	import hljs from 'highlight.js/lib/core';
	import json from 'highlight.js/lib/languages/json';
	import Address_Select_Modal from './Address_Select_Modal.svelte';
	import { browser } from '$app/environment';
	import { validateCity, validateState, validateStreet, validateZip } from './Address2';
	import { getInputMask, MaskHandler } from '../mask';
	import { KTIForm, ServerDataValidation } from '../form';
	import { FormController } from '../actions';
	import * as _ from 'lodash';
	import { states } from './Address2_abbr';
	let zipMaskHandler: MaskHandler;
	let address_select_modal: Address_Select_Modal;
	export let Valid: boolean = false;
	export let Config: Address2Config;
	export let ShowMetadata: boolean = false;
	export let ReadOnly: boolean = false;
	export let Disabled: boolean = false;
	export let SaveData: boolean = true;
	const autocompletePrefix = `section-addr${InstanceID}${
		Config.ShippingAddress ? ' shipping' : Config.BillingAddress ? ' billing' : ''
	} `;
	const requiresCheck =
		Config.UseForParticipationCheck ||
		Config.UseForProductCheck ||
		Config.UseForSubmissionDupCheck ||
		Config.UseForInstanceCheck;
	let serverValidation: ServerDataValidation | null = requiresCheck
		? KTIForm.addServerValidation('email', Config.id)
		: null;
	let Shown = Config.Shown;
	let StreetEl: HTMLInputElement;
	let StreetLabelEl: HTMLElement;
	let CityEl: HTMLInputElement;
	let StateEl: HTMLInputElement;
	let PostCodeEl: HTMLInputElement;
	let ErrorEl: HTMLElement;
	let CityErrorEl: HTMLElement;
	let StateErrorEl: HTMLElement;
	let ZipErrorEl: HTMLElement;
	let AutoCompleteEl: HTMLElement | null;
	let autocompleteObj: any;
	let isAutocompleteOpen = false;
	let autocomplete_destroyed = false;
	let suggestions: IAddress[] = [];
	//let sug_strs: string[] = [];
	let inputVal: string = '';
	export let useOtherAddress = false;
	let lastAddressCheckValue: object = { street: '', city: '', state: '', zipcode: '' };
	let POPrefixes = ['post o', 'po ', 'p.o'];
	let lookupComplete = false;
	let addressCheckRunning = false;
	let addressCheckComplete = false;
	let google_session_id = '';
	let validated = false;
	let metacode_html = '';
	let validatecode_html = '';
	let do_secondary_lookup = false;
	let secondary_lookup_params: URLSearchParams;
	let is_focused = false;
	let skip_body_focus = false;
	let last_suggestion: IAddress & any = {
		_str: '',
		street: '',
		city: '',
		state: '',
		zipcode: ''
	};
	let google_validated_address = false;

	export function show() {
		Config.Shown = true;
	}

	export function hide() {
		Config.Shown = false;
	}

	export function getValue(): any {
		return {
			street: StreetEl.value,
			city: cityVal,
			state: stateVal,
			zipcode: zipMaskHandler.getValue()
		};
	}

	export async function setValue(address: IAddress) {
		if (address === null) {
			last_suggestion = {
				_str: '',
				street: '',
				city: '',
				state: '',
				zipcode: ''
			};
		} else {
			last_suggestion = address;
		}
		//validate incoming values
		if (!Config.AllowPOBox) {
			if (POPrefixes.some((v) => last_suggestion.street.toLowerCase().startsWith(v))) {
				//setInvalid('Please enter a valid physical address (PO Boxes are not allowed)');
				clearAddress();
				KTIForm.error_modal.Show(
					`Unable to use selected address, please enter a valid physical address (PO Boxes are not allowed).`
				);
				//Uncheck the checkbox
				useOtherAddress = false;
				return;
			}
		}
		if (Config.BlockedStates.includes(last_suggestion.state)) {
			KTIForm.error_modal.Show(Config.BlockedStateErrMsg);
			clearAddress();
			setInvalid('We are unable to ship to this location');
			return;
		}
		StreetEl.value = last_suggestion.street ?? '';
		cityVal = last_suggestion.city ?? '';
		stateVal = last_suggestion.state ?? '';
		zipVal = last_suggestion.zipcode ?? '';
		zipMaskHandler.override(last_suggestion.zipcode ?? '');
		setRelatedAddresses(last_suggestion);
		if (serverValidation && address) {
			let valid = await serverValidation?.validate_value(last_suggestion);
			if (KTIForm.form_config.ShowImmediateEmailPhoneAddressErrors) {
				if (!valid) {
					KTIForm.error_modal.Show(Config.FailedCheckMsg);
					clearAddress();
					setInvalid();
				}
			}
		}
		// if (address.zipcode) {
		// 	zipMaskHandler.override(address.zipcode);
		// } else {
		// 	zipMaskHandler.override('');
		// }
	}

	function setRelatedAddresses(address: IAddress) {
		//Make sure target address component will accept the address
		for (let address2Comp of Config.RelatedAddress2) {
			let relatedAddress2 = FormController.get_component(address2Comp.componentId);
			let relatedAddress2Comp: Address2 = relatedAddress2?.Comp as unknown as Address2;
			if (relatedAddress2Comp.useOtherAddress) {
				relatedAddress2Comp.setValue(address);
			}
		}
	}

	function setAddress(suggestion: IAddress) {
		if (Disabled) {
			return;
		}
		if (useOtherAddress) {
			return;
		}
		last_suggestion = suggestion;
		StreetEl.value = suggestion.street;
		cityVal = suggestion.city;
		stateVal = suggestion.state;
		zipMaskHandler.override(suggestion.zipcode);
		activeClass = true;
		setRelatedAddresses(suggestion);
		//sug_strs = [];
		setValid();
	}
	// async function isBlurred() {
	// 	return new Promise((resolve, reject) => {
	// 		setTimeout(() => {
	// 			resolve(
	// 				StreetEl !== document.activeElement &&
	// 					CityEl !== document.activeElement &&
	// 					StateEl !== document.activeElement &&
	// 					PostCodeEl !== document.activeElement
	// 			);
	// 		}, 0);
	// 	});
	// }
	async function setAddressModified() {
		validated = false;
	}
	let autofill_detected = false;

	async function doAddressLookup(query: string): Promise<Response> {
		if (do_secondary_lookup) {
			isStreetValid = false;
			isStreetInvalid = false;
			const search = secondary_lookup_params.get('search');
			if (search) {
				StreetEl.value = search;
			}
			do_secondary_lookup = false;
			return await fetch(
				`${PUBLIC_ADDRESS_SERVICE_DOMAIN}/v1/addresses/autocomplete?${secondary_lookup_params.toString()}`,
				{
					method: 'GET',
					headers: {
						Accept: 'application/json',
						'x-api-key': '12345678'
					}
				}
			);
		} else {
			let queryParams = new URLSearchParams({
				search: query,
				use_google: Config.UseGoogleAutocomplete ? 'true' : 'false',
				use_smarty: Config.UseSmartyAutocomplete ? 'true' : 'false',
				google_session_id,
				allowIntl: Config.AllowINTL ? '1' : '0'
			}).toString();
			return await fetch(
				`${PUBLIC_ADDRESS_SERVICE_DOMAIN}/v1/addresses/autocomplete?${queryParams.toString()}`,
				{
					method: 'GET',
					headers: {
						Accept: 'application/json',
						'x-api-key': '12345678'
					}
				}
			);
		}
	}

	const addressFilter = async (query: string) => {
		console.log('addressFilter:', query);
		let autocompletes = document.querySelectorAll("[id^='autocomplete-dropdown-Street_Outline_']");
		let do_autofill = false;
		if (autofill_detected) {
			autofill_detected = false;
			do_autofill = true;
			query = StreetEl.value + ' ' + cityVal + ', ' + stateVal + ' ' + zipMaskHandler.getValue();
		}
		lookupComplete = false;
		const starting_values = {
			street: StreetEl.value,
			city: cityVal,
			state: stateVal,
			zipcode: zipMaskHandler.getValue()
		};
		// If the user has changed the address while the fetch was in progress, don't show the suggestions, there will be another fetch
		if (
			starting_values.street != StreetEl.value ||
			starting_values.city != cityVal ||
			starting_values.state != stateVal ||
			starting_values.zipcode != zipMaskHandler.getValue()
		) {
			return;
		}
		if (autofill_detected) {
			return;
		}
		let response = await doAddressLookup(query);
		if (response.status != 200) {
			return [];
		}
		let data = await response.json();
		//Should we switch to a secondary lookup?
		if (data.suggestions && data.suggestions.length == 1) {
			const suggestion: IAddress = buildAddress(data.suggestions[0]);
			console.log('Only one suggestion');
			if (suggestion.needNumber) {
				console.log('Only one suggestion that needs unit number');
				//Switch to secondary lookup
				do_secondary_lookup = true;
				secondary_lookup_params = new URLSearchParams({
					search: StreetEl.value,
					selected: suggestion._str,
					//use_google: Config.UseGoogleAutocomplete ? 'true' : 'false',
					use_smarty: Config.UseSmartyAutocomplete ? 'true' : 'false'
					//google_session_id,
					//allowIntl: Config.AllowINTL ? '1' : '0'
				});
				StreetEl.value = suggestion.street;
				response = await doAddressLookup('');
				data = await response.json();
			}
		}

		suggestions = new Array();
		//any results
		console.log('activeElement:', document.activeElement, 'StreetEl:', StreetEl);
		if (data.suggestions && data.suggestions.length > 0) {
			if (data.google_session_id) {
				google_session_id = data.google_session_id;
			}
			console.log('data', data);
			for (let i = 0; i < data.suggestions.length; i++) {
				//Remove PO boxes if not allowed
				// if (
				// 	!Config.AllowPOBox &&
				// 	POPrefixes.some((v) => data.suggestions[i].street_line.toLowerCase().startsWith(v))
				// ) {
				// 	continue;
				// }
				suggestions.push(buildAddress(data.suggestions[i]));
			}
			//unhide the autocomplete
			for (let autocomplete of autocompletes) {
				if (autocomplete) {
					let child = autocomplete.querySelector('.autocomplete-dropdown');
					//Add 'open' class if not already there
					//Both open and block could be dynamic based on a single variable like "showAutocomplete: boolean"
					if (child && !child.classList.contains('open')) {
						console.log('open was missing and added');
						child.classList.add('open');
					}
					autocomplete.style.display = 'block';
				}
			}
		} else {
			//No suggestions, hide autocomplete
			for (let autocomplete of autocompletes) {
				if (autocomplete) {
					autocomplete.style.display = 'none';
				}
			}
		}
		let hasMatch = suggestions.some((s) => {
			//console.log(s, StreetEl.value);
			//If smarty
			if (s.type == 'smarty') {
				return s.street.toLowerCase() == StreetEl.value.toLowerCase();
			} else {
				return s.street.toLowerCase().includes(StreetEl.value.toLowerCase());
			}
		});
		// if (suggestions.length == 0) {
		// 	setTimeout(() => {
		// 		autocompleteObj.close();
		// 		autocompleteObj.dispose();
		// 		createAutocomplete();
		// 	}, 1);
		// }
		if (hasMatch && suggestions.length == 1 && do_autofill) {
			console.log('one suggestion and match');
			if (suggestions[0].type == 'smarty') {
				setAddress(suggestions[0]);
				setTimeout(() => {
					autocompleteObj.close();
					autocompleteObj.dispose();
					createAutocomplete();
					for (let autocomplete of autocompletes) {
						if (autocomplete) {
							autocomplete.style.display = 'none';
						}
					}
				}, 1);
			} else {
				selectGooglePlace(suggestions[0]);
				setTimeout(() => {
					autocompleteObj.close();
					autocompleteObj.dispose();
					createAutocomplete();
					for (let autocomplete of autocompletes) {
						if (autocomplete) {
							autocomplete.style.display = 'none';
						}
					}
				}, 1);
			}
		}
		return suggestions;
	};
	let mdb: any;
	function createAutocomplete() {
		autocompleteObj = new mdb.Autocomplete(AutoCompleteEl, {
			filter: addressFilter, //What to display in the textbox after selecting value from itemContent()
			threshold: 3, //Don't start searching until this number of characters have been entered
			debounce: 500, //Delay between requests, prevent spam when typing or entering text quickly
			autoSelect: true, //Why isn't this working?!
			itemContent: (suggestion: any) => {
				//What to show
				//get the ._str from the suggestions array
				//console.log(suggestion);
				return suggestion._str;
			}
			//displayValue: (value) => value.name
		});
	}

	async function selectGooglePlace(selection: any) {
		console.log('google address selected');
		//get details from google

		let queryParams = new URLSearchParams({
			place_id: selection.google_place_id ?? '',
			session_id: google_session_id,
			get_metadata: Config.ShowMetadata ? '1' : '0'
		});
		let response = await fetch(
			`${PUBLIC_ADDRESS_SERVICE_DOMAIN}/v1/addresses/google_select?${queryParams.toString()}`,
			{
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'x-api-key': '12345678'
				}
			}
		);

		if (response.status != 200) {
			//show error message

			return;
		}
		let data = await response.json();
		//Check if the address is valid
		if (data.valid === false) {
			if (
				'secondary_required' in data.data &&
				data.data?.error &&
				(data.data.secondary_required === true || data.data.secondary_valid === false)
			) {
				data.data.base_address.zipcode = data.data.base_address.zip;
				setAddress(data.data.base_address);
			}
			setInvalid(data.data.error);
			return;
		}
		let address: IAddress = data.address;
		if (ShowMetadata) {
			metacode_html = hljs.highlight(JSON.stringify(data), {
				language: 'json'
			}).value;
		}
		address.zipcode = address.zip;
		setAddress(address);
		console.log('google data', data);
	}
	let is_setup = false;

	function amIFocused(el: HTMLElement | null) {
		return [StreetEl, CityEl, StateEl, PostCodeEl, AutoCompleteEl].includes(el);
	}

	function validateBlur() {
		console.log(StreetEl, CityEl, StateEl, PostCodeEl, AutoCompleteEl);

		if (!Config.AllowPOBox) {
			if (POPrefixes.some((v) => StreetEl.value.toLowerCase().startsWith(v))) {
				//setInvalid('Please enter a valid physical address (PO Boxes are not allowed)');
				clearAddress();
				KTIForm.error_modal.Show(
					`Unable to use selected address, please enter a valid physical address (PO Boxes are not allowed).`
				);
				return;
			}
		}
		if (Config.BlockedStates.includes(stateVal)) {
			KTIForm.error_modal.Show(Config.BlockedStateErrMsg);
			setInvalid('We are unable to ship to this location');
			return;
		}
		// console.log("I've been blurred", document.activeElement);
		// //is autocomplete drop down open?
		// //if so, wait for it to close
		// console.log('Active Element before:', document.activeElement);
		// await new Promise((resolve, reject) => {
		// 	let interval = setInterval(() => {
		// 		if (!isAutocompleteOpen) {
		// 			clearInterval(interval);
		// 			resolve(1);
		// 		}
		// 	}, 10);
		// });
		// console.log('Active Element after:', document.activeElement);
		//Basic Validation
		let passes_basic = true;
		let valid_street: string | true = validateStreet(StreetEl.value);
		if (valid_street === true) {
			ErrorEl.style.display = 'none';
		} else {
			setInvalid(valid_street);
			passes_basic = false;
		}
		let valid_city: string | true = validateCity(cityVal);
		if (valid_city === true) {
			CityErrorEl.style.display = 'none';
		} else {
			CityErrorEl.innerHTML = valid_city;
			CityErrorEl.style.display = 'block';
			passes_basic = false;
		}
		let valid_state: string | true = validateState(stateVal);
		if (valid_state === true) {
			StateErrorEl.style.display = 'none';
		} else {
			StateErrorEl.innerHTML = valid_state;
			StateErrorEl.style.display = 'block';
			passes_basic = false;
		}
		let valid_zip: string | true = validateZip(zipMaskHandler.getValue());
		if (valid_zip === true) {
			ZipErrorEl.style.display = 'none';
		} else {
			ZipErrorEl.innerHTML = valid_zip;
			ZipErrorEl.style.display = 'block';
			passes_basic = false;
		}
		if (!passes_basic) {
			console.log('basic validation failed', valid_street, valid_city, valid_state, valid_zip);
			return;
		}

		if (!validated) {
			validate_address();
		}
		setTimeout(validate, 50);
	}

	const streetElMutationCB = (mutationsList: MutationRecord[]) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'autocomplete') {
				if (StreetEl.getAttribute('autocomplete') !== `${autocompletePrefix}street-address`) {
					console.log('setting autocomplete on street element');
					StreetEl.setAttribute('autocomplete', `${autocompletePrefix}street-address`);
				}
			}
		}
	};

	onMount(async () => {
		const observer = new MutationObserver(streetElMutationCB);
		observer.observe(StreetEl, { attributes: true });

		if (serverValidation) {
			serverValidation.valid = false;
		}
		if (!is_setup) {
			is_setup = true;
			zipMaskHandler = new MaskHandler('99999', PostCodeEl);
			if (
				[StreetEl, CityEl, StateEl, PostCodeEl, AutoCompleteEl].includes(
					document.activeElement as HTMLElement
				)
			) {
				is_focused = true;
			}
			//This does not detect autocompletes because there is no focus event
			activeElement.subscribe(async (el) => {
				// if (isAutocompleteOpen) {
				// 	console.log('autocomplete is open, skipping focus event');
				// 	return;
				// }
				//Body is focused for a millesecond after closing the autocomplete
				if (skip_body_focus && el == document.body) {
					skip_body_focus = false;
					return;
				}
				if (amIFocused(el as HTMLElement)) {
					if (!is_focused) {
						is_focused = true;
					}
				} else {
					//Focus lost
					if (is_focused) {
						is_focused = false;
						validateBlur();
					}
				}
			});
		}

		hljs.registerLanguage('json', json);
		if (!Config.Title) {
			Config.Title = 'Address:';
		}
		mdb = await import('mdb-ui-kit');
		const { Input } = await import('mdb-ui-kit');
		//AutoCompleteEl = document.getElementById(`Street_Outline_${InstanceID}`);
		if (!AutoCompleteEl) {
			console.log('AutoCompleteEl is null');
			return;
		}
		new Input(AutoCompleteEl).init();
		createAutocomplete();
		AutoCompleteEl.addEventListener('open.mdb.autocomplete', (e) => {
			isAutocompleteOpen = true;
			console.log('opened');
			if (
				(!do_secondary_lookup && document.activeElement !== StreetEl) ||
				suggestions?.length == 0
			) {
				console.log('closing');
				setTimeout(() => {
					autocompleteObj.close();
					autocompleteObj.dispose();
					createAutocomplete();
				}, 1);
			}
			//console.log('open:', e);
			//console.log('Autocomplete opened');
			//console.log('Suggestions:', suggestions);
		});
		AutoCompleteEl.addEventListener('itemSelect.mdb.autocomplete', async (e: any) => {
			console.log('itemSelect:', e);
			//skip_body_focus = true;
			//console.log('value:', e.value);
			let addr_info = e.value as IAddress;
			console.log('addr_info:', addr_info);
			//Is this a PO Box and we don't allow PO Boxes?
			if (!Config.AllowPOBox && addr_info.is_po_box) {
				setInvalid('Please enter a valid physical address (PO Boxes are not allowed)');
				return;
			}
			if (Config.BlockedStates.includes(addr_info.state)) {
				KTIForm.error_modal.Show(Config.BlockedStateErrMsg);
				setInvalid('We are unable to ship to this location');
				return;
			}
			//Is this a secondary address?
			if (addr_info.needNumber) {
				//StreetEl.value = addr_info.street;
				do_secondary_lookup = true;
				secondary_lookup_params = new URLSearchParams({
					search: addr_info.street,
					selected: addr_info._str,
					//use_google: Config.UseGoogleAutocomplete ? 'true' : 'false',
					use_smarty: Config.UseSmartyAutocomplete ? 'true' : 'false'
					//google_session_id,
					//allowIntl: Config.AllowINTL ? '1' : '0'
				});
				return;
				//console.log(e.value);
				do_secondary_lookup = true;
				// autocompleteObj.close();
				// autocompleteObj.dispose();
				//console.log(autocompleteObj);
				// createAutocomplete();
				secondary_lookup_params = new URLSearchParams({
					search: StreetEl.value,
					selected: addr_info._str,
					//use_google: Config.UseGoogleAutocomplete ? 'true' : 'false',
					use_smarty: Config.UseSmartyAutocomplete ? 'true' : 'false'
					//google_session_id,
					//allowIntl: Config.AllowINTL ? '1' : '0'
				});
				StreetEl.value = addr_info.street;
				// changeit();
				// setAddressModified();
				// inputVal = e.target?.value;
				// if (!Config.AllowPOBox && POPrefixes.some((v) => inputVal.toLowerCase().startsWith(v))) {
				// 	setInvalid('Please enter a valid physical address');
				// } else {
				// 	ErrorEl.innerHTML = 'Invalid street address';
				// }
				return;
			}

			//Was Google address selected?
			console.log('e.value:', e.value);
			if (e.value.type == 'google') {
				await selectGooglePlace(e.value);
			} else {
				setAddress(e.value as IAddress);
			}
			validate_address();
			//checkAddress();
		});
		AutoCompleteEl.addEventListener('close.mdb.autocomplete', (e) => {
			console.log('closed');
			if (do_secondary_lookup) {
				StreetEl.value = secondary_lookup_params.get('search') ?? '';
				document.autocompleteObj = autocompleteObj;
				//Wait until autocompleteObj._isOpen is false
				const waitForAutocompleteClose = () => {
					return new Promise((resolve) => {
						const interval = setInterval(() => {
							if (!autocompleteObj._isOpen) {
								clearInterval(interval);
								resolve(true);
							}
							console.log('waiting for autocomplete to close');
						}, 10);
					});
				};

				waitForAutocompleteClose().then(() => {
					autocompleteObj.open();
					autocompleteObj.search(StreetEl.value);
				});
				// setTimeout(() => {
				// 	autocompleteObj.close();
				// 	autocompleteObj.dispose();
				// 	createAutocomplete();
				// }, 1);
				// autocompleteObj.close();
				// autocompleteObj.dispose();
				//console.log(autocompleteObj);
				//createAutocomplete();
				return;
			}
			isAutocompleteOpen = false;
			if (StreetEl.value === '[object Object]') {
				StreetEl.value = last_suggestion.street;
			}
			//console.log('e', e);
			// let listBoxIndex = sug_strs.indexOf(StreetEl.value);
			// //console.log('sug_strs', sug_strs);
			// //console.log('suggestions', suggestions);
			// if (listBoxIndex == -1) {
			// 	//not found
			// 	return;
			// }
			// let sugg = suggestions[listBoxIndex]; //lookup suggestion based on string selected
			// setAddress(sugg);
			// checkAddress();
			//addressClick(sugg);
		});

		//Check for and handle autofill
		checkForAutofill();
		//return async () => {observer.disconnect()};
	});

	let last_street = '';
	let last_city = '';
	let last_state = '';
	let last_zip = '';
	async function checkForAutofill() {
		if (
			StreetEl.value != last_street &&
			cityVal != last_city &&
			stateVal != last_state &&
			zipMaskHandler.getValue() != last_zip
		) {
			//When all fields are changed at once, it's likely autofill
			console.log('autofill detected');
			autofill_detected = true;

			//autocomplete lookup has started (we need to stop it or wait until it is done to do a autofill lookup, unless only one result is returned then just auto select that)
			//Wait until drop down is opened (first set of results is returned from server)
			// await new Promise((resolve, reject) => {
			// 	let interval = setInterval(() => {
			// 		if (!isAutocompleteOpen) {
			// 			clearInterval(interval);
			// 			resolve(1);
			// 		}
			// 	}, 10);
			// });
		}
		last_street = StreetEl.value;
		last_city = cityVal;
		last_state = stateVal;
		last_zip = zipMaskHandler.getValue();
		setTimeout(() => {
			checkForAutofill();
		}, 10);
	}

	let isInvalid = false;
	let isStreetInvalid = false;
	let isCityInvalid = false;
	let isStateInvalid = false;
	let isZipInvalid = false;
	let isValid = false;
	let isStreetValid = false;
	let isCityValid = false;
	let isStateValid = false;
	let isZipValid = false;
	let activeClass = false;
	export function setInvalid(errorMsg?: string) {
		if (serverValidation) {
			serverValidation.valid = false;
		}
		Valid = false;
		isInvalid = true;
		isValid = false;
		activeClass = false;
		if (errorMsg) {
			ErrorEl.innerHTML = errorMsg;
			ErrorEl.style.display = 'block';
		} else {
			ErrorEl.style.display = 'none';
		}
	}
	export async function doServerValidation() {
		tick();
		if (serverValidation) {
			if (serverValidation.validated) {
				//Zipcode will change when plus 4 is added (don't rerun validation just because of that); only if street and/or state changes
				if (
					serverValidation.value &&
					serverValidation.value.street == StreetEl.value &&
					serverValidation.value.city == cityVal &&
					serverValidation.value.state == stateVal
				) {
					return;
				} else {
					serverValidation.reset_validation();
				}
			}
			let data_packet: any = {
				street: StreetEl.value,
				city: CityEl.value,
				state: stateVal,
				zipcode: zipMaskHandler.getValue()
			};
			//Are we attached to a DealerSelector?
			console.log('Config.DealerSelector:', Config.DealerSelectorComp);
			if (Config.DealerSelectorComp && !Config.DealerSelectorComp.AllowDuplicateEntries) {
				let my_street_field = `${Config.DBCol}street`;
				let my_city_field = `${Config.DBCol}city`;
				let my_state_field = `${Config.DBCol}state`;
				let my_zip_field = `${Config.DBCol}zipcode`;
				let dealerSelectorComp = FormController.get_component(
					Config.DealerSelectorComp.componentId
				);
				if (!dealerSelectorComp) {
					console.error('DealerSelectorComp not found');
					return;
				}
				let dealer_street_field = `${dealerSelectorComp.DBCol}line1`;
				let dealer_city_field = `${dealerSelectorComp.DBCol}city`;
				let dealer_state_field = `${dealerSelectorComp.DBCol}state`;
				let dealer_zip_field = `${dealerSelectorComp.DBCol}zipcode`;
				data_packet.street_fields = my_street_field + ',' + dealer_street_field;
				data_packet.city_fields = my_city_field + ',' + dealer_city_field;
				data_packet.state_fields = my_state_field + ',' + dealer_state_field;
				data_packet.zipcode_fields = my_zip_field + ',' + dealer_zip_field;
			}
			let valid = await serverValidation.validate_value(data_packet);
			if (KTIForm.form_config.ShowImmediateEmailPhoneAddressErrors) {
				if (!valid) {
					clearAddress();
					setInvalid();
					KTIForm.error_modal.Show(Config.FailedCheckMsg);
				}
			}
		}
	}
	export function setNuetral() {
		Valid = false;
		isValid = false;
		isStateValid = false;
		isCityValid = false;
		isStreetValid = false;
		isZipValid = false;
		isInvalid = false;
		isStreetInvalid = false;
		isCityInvalid = false;
		isStateInvalid = false;
		isZipInvalid = false;
		ErrorEl.style.display = 'none';
		CityErrorEl.style.display = 'none';
		StateErrorEl.style.display = 'none';
		ZipErrorEl.style.display = 'none';
	}
	export function setValid() {
		Valid = true;
		isValid = true;
		isStateValid = true;
		isCityValid = true;
		isStreetValid = true;
		isZipValid = true;
		isInvalid = false;
		isStreetInvalid = false;
		isCityInvalid = false;
		isStateInvalid = false;
		isZipInvalid = false;

		ErrorEl.style.display = 'none';
		CityErrorEl.innerHTML = '';
		CityErrorEl.style.display = 'none';
		StateErrorEl.innerHTML = '';
		StateErrorEl.style.display = 'none';
		ZipErrorEl.innerHTML = '';
		ZipErrorEl.style.display = 'none';
		Event.trigger('addressValid');
		let recheck =
			lastAddressCheckValue.street != StreetEl.value ||
			lastAddressCheckValue.city != cityVal ||
			lastAddressCheckValue.state != stateVal ||
			lastAddressCheckValue.zipcode != zipMaskHandler.getValue();
		// if (requiresCheck && recheck) {
		// 	lastAddressCheckValue = {
		// 		street: StreetEl.value,
		// 		city: cityVal,
		// 		state: stateVal,
		// 		zipcode: zipMaskHandler.getValue()
		// 	};
		// 	lastAddressCheckValue = StreetEl.value;
		// 	addressChecked = false;
		// 	lastAddressGood = false;

		// 	Store.addressPassed.set(false);
		// 	Store.addressValidating.set(true);
		// 	Store.addressValidationResult.set('');
		// 	const queryParams = new URLSearchParams({
		// 		street: StreetEl.value,
		// 		state: stateVal,
		// 		zipcode: zipMaskHandler.getValue()
		// 	}).toString();
		// 	const res = REST.GET('check', {
		// 		street: StreetEl.value,
		// 		state: stateVal,
		// 		zipcode: zipMaskHandler.getValue()
		// 	}).then(async (res) => {
		// 		if (res.ok) {
		// 			addressChecked = true;
		// 			let data = await res.json();
		// 			console.log('address check:', data);
		// 			if ('bad' in data && !data.bad) {
		// 				Store.addressPassed.set(true);
		// 				lastAddressGood = true;
		// 			} else {
		// 				Store.addressValidationResult.set(data.reason);
		// 			}
		// 		} else {
		// 			console.log('address check failed:', res);
		// 		}
		// 		Store.addressValidating.set(false);
		// 	});
		// }
		activeClass = true;
		doServerValidation();
	}
	export function focus() {
		StreetEl.focus();
	}
	export async function validate_address() {
		if (useOtherAddress) {
			addressCheckComplete = true;
			addressCheckRunning = false;
			validated = true;
			return;
		}
		if (addressCheckRunning && !addressCheckComplete) return;
		addressCheckRunning = true;
		addressCheckComplete = false;
		let url = `${PUBLIC_ADDRESS_SERVICE_DOMAIN}/v1/addresses/validate`;
		let body = {
			street: StreetEl.value,
			city: cityVal,
			state: stateVal,
			zip: zipMaskHandler.getValue(),
			country: 'US',
			//ignore_autocomplete_cache: '0',
			google_session_id
		};
		if (!body.street) {
			const parts = [cityVal, stateVal, zipMaskHandler.getValue()].filter((part) =>
				part ? part.trim() !== '' : false
			);
			body.street = parts.join(',');
			if (!body.street.trim()) {
				addressCheckComplete = true;
				addressCheckRunning = false;
				validated = true;
				setInvalid();
				return;
			}
		}
		let res = await fetch(url, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				Accept: 'application/json',
				'x-api-key': '12345678',
				'Content-Type': 'application/json'
			}
		});
		let data = await res.json().catch((e) => {
			console.log(e);
		});
		if (data) {
			if (data?.valid === true) {
				if (data.data?.FormattedAddress) {
					//Check for replaced values
					if (
						(!data.data.suggestions || data.data.suggestions.length == 0) &&
						data.data?.address &&
						data.data.address?.addressComponents
					) {
						for (let component of data.data.address.addressComponents) {
							if (component.componentType == 'locality' && component?.replaced) {
								let suggestion = {
									street_line: data.data.FormattedAddress.street,
									city: data.data.FormattedAddress.city,
									state: data.data.FormattedAddress.state,
									zip: data.data.FormattedAddress.zip
								};
								data.data.suggestions.push(suggestion);
							}
						}
					} else {
						//Update zipcode
						let zip = data.data.FormattedAddress.zip;
						zipMaskHandler.override(zip);
						//Update fields
						StreetEl.value = data.data.FormattedAddress.street;
						cityVal = data.data.FormattedAddress.city;
						stateVal = data.data.FormattedAddress.state;
						setValid();
					}
				} else {
					setInvalid();
				}
			} else {
				if (
					'secondary_required' in data.data &&
					data.data?.error &&
					(data.data.secondary_required === true || data.data.secondary_valid === false)
				) {
					setInvalid(data.data.error);
				} else if (data.data?.suggestions) {
					//Do we have suggestions to show?
					//Ask user to select an address
					if (
						data?.data?.suggestions?.suggestions &&
						data.data.suggestions.suggestions.length > 0
					) {
						console.log('suggestions', data.data.suggestions.suggestions);
						address_select_modal.Show(
							StreetEl.value,
							cityVal,
							stateVal,
							zipMaskHandler.getValue(),
							data.data.suggestions.suggestions
						);
					} else {
						address_select_modal.Show(
							StreetEl.value,
							cityVal,
							stateVal,
							zipMaskHandler.getValue(),
							[]
						);
					}
					//setInvalid();
				} else if (data?.added_unit_type) {
					console.log('unit type was missing', data);
					address_select_modal.Show(
						StreetEl.value,
						cityVal,
						stateVal,
						zipMaskHandler.getValue(),
						[
							{
								street_line: data.data.FormattedAddress.street,
								city: data.data.FormattedAddress.city,
								state: data.data.FormattedAddress.state,
								zipcode: data.data.FormattedAddress.zip,
								secondary: ''
							}
						],
						'The unit type was missing from the address you entered. Please select the address with the most accurate unit type.'
					);
				} else {
					address_select_modal.Show(
						StreetEl.value,
						cityVal,
						stateVal,
						zipMaskHandler.getValue(),
						[]
					);
				}
			}
		}
		if (ShowMetadata) {
			validatecode_html = hljs.highlight(JSON.stringify(data), {
				language: 'json'
			}).value;
		}
		console.log('validate_address:', data);
		addressCheckComplete = true;
		addressCheckRunning = false;
		validated = true;
	}

	function setSuggestedAddress(suggestion: any) {
		//If google suggestion then we need to get the details
		if (suggestion.data_source == 'google') {
			selectGooglePlace(suggestion);
			address_select_modal.Hide();
			return;
		}
		StreetEl.value = suggestion.street_line;
		cityVal = suggestion.city;
		stateVal = suggestion.state;
		zipMaskHandler.override(suggestion.zipcode);
		activeClass = true;
		addressCheckComplete = false;
		google_validated_address = true;
		address_select_modal.Hide();
		validate();
		//TODO Validate
	}

	function selectEnteredAddress() {
		setValid();
		validated = true;
		google_validated_address = false;
		address_select_modal.Hide();
	}
	export async function validate() {
		//if not save, then don't validate
		if (!SaveData) {
			return true;
		}
		//Set max wait of 5 seconds
		console.log('##validate() called', addressCheckComplete, addressCheckRunning);
		if (!addressCheckComplete) {
			if (!addressCheckRunning) {
				validate_address();
			}
			return await new Promise((resolve, reject) => {
				setTimeout(() => {
					resolve(validate());
				}, 50);
			});
		}

		//console.log('Validating ADDRESS', Config.Required, useOtherAddress, StreetEl.value);
		if (useOtherAddress) {
			setValid();
		} else if (Config.Required) {
			console.log('Suggestions:', suggestions);
			if (StreetEl.value == '') {
				//setInvalid('Please enter a street address');
			} else if (suggestions.length > 0) {
				for (let suggestion of suggestions) {
					if (suggestion.is_secondary) {
						continue;
					}
					let valid = true;

					if (suggestion.street != StreetEl.value) {
						valid = false;
					}
					if (suggestion.city != cityVal) {
						valid = false;
					}
					if (suggestion.state != stateVal) {
						valid = false;
					}
					if (suggestion.zipcode != zipMaskHandler.getValue()) {
						valid = false;
					}
					if (valid) {
						setValid();
					}
				}
			} else if (suggestions.length == 1) {
				let sugg = suggestions[0]; //lookup suggestion based on string selected
				setAddress(sugg);
			} else if (!Valid) {
				console.log('validate - setInvalid');
				//setInvalid('Invalid street address');
			}
		}
		if (Valid && !useOtherAddress) {
			Store.formData.setValues({
				[Config.DBCol + 'street']: StreetEl.value ?? '',
				[Config.DBCol + 'city']: cityVal ?? '',
				[Config.DBCol + 'state']: stateVal ?? '',
				[Config.DBCol + 'zipcode']: zipMaskHandler.getValue() ?? ''
			});
		}
		return Valid;
	}
	export function appendData(formData: FormData) {
		if (!SaveData) {
			formData.append('dont_save_columns', Config.DBCol + 'street');
			formData.append('dont_save_columns', Config.DBCol + 'city');
			formData.append('dont_save_columns', Config.DBCol + 'state');
			formData.append('dont_save_columns', Config.DBCol + 'zipcode');
			return;
		}
		if (!useOtherAddress) {
			formData.append(Config.DBCol + 'street', StreetEl.value);
			formData.append(Config.DBCol + 'city', cityVal);
			formData.append(Config.DBCol + 'state', stateVal);
			formData.append(Config.DBCol + 'zipcode', zipMaskHandler.getValue() ?? '');
			formData.append(
				Config.DBCol + 'google_validated_address',
				google_validated_address.toString()
			);
		} else {
			formData.append(Config.DBCol + 'street', StreetEl.value);
			formData.append(Config.DBCol + 'city', cityVal);
			formData.append(Config.DBCol + 'state', stateVal);
			formData.append(Config.DBCol + 'zipcode', zipMaskHandler.getValue() ?? '');
		}
	}
	function secondaryCheck(e: InputEvent) {
		// let longer_suggestions = suggestions.filter((s) => s.street.length > e.target?.value.length);
		// //Check suggestions to see if the current value is in the list and if it is a secondary address with a unit type
		// if (longer_suggestions.length == 1) {
		// 	let suggestion = longer_suggestions[0];
		// 	//Compare street against suggestion.street + ' ' + suggestions.secondary if secondary is not ''
		// 	//If text value = suggestion.street + ' ' then automatically add the secondary value
		// 	if (suggestion.unit_type) {
		// 		//remove the unit type from the street
		// 		let street = suggestion.street.replace(suggestion.unit_type, '').trim();
		// 		if (street + ' ' == e.target?.value) {
		// 			e.target.value = suggestion.street;
		// 			e.target.setSelectionRange(e.target.value.length, e.target.value.length);
		// 		}
		// 	}
		// }
	}
	function changeit() {
		changing = true;
		setTimeout(() => {
			changing = false;
		}, 500);
	}
	let changing = false;
	let cityVal = '';
	let stateVal = '';
	let zipVal = '';
	function clearAddress() {
		StreetEl.value = '';
		cityVal = '';
		stateVal = '';
		zipMaskHandler.override('');
		setNuetral();
		activeClass = false;
	}

	function getRelatedAddress2Value() {
		if (!useOtherAddress) {
			return;
		}
		let relatedAddress2 = FormController.get_component(Config.AnotherAddressId);
		let relatedAddress2Comp: Address2 = relatedAddress2.Comp;
		if (relatedAddress2Comp) {
			console.log('relatedAddress2Comp:.getValue()', relatedAddress2Comp.getValue());
			setValue(relatedAddress2Comp.getValue());
		}
	}

	const validateBlurDebounced = _.debounce(validateBlur, 50);
</script>

<FormGroup {Config}>
	<div class="col-6" style="margin-bottom: 0px">
		<div class="comp-title">{Config.Title}</div>
	</div>
	{#if Config.AnotherAddressId != null}
		<div class="col-6" style="margin-bottom: 0px">
			<div class="form-check">
				<input
					class="form-check-input"
					type="checkbox"
					name="useOtherAddress"
					bind:checked={useOtherAddress}
					on:change={(e) => {
						clearAddress();
						getRelatedAddress2Value();
					}}
				/>
				<label class="form-check-label" for="useOtherAddress"
					><div class="comp-title">{Config.UseAnotherAddressDesc}</div></label
				>
			</div>
		</div>
	{/if}
	<div class="col-12">
		<div class="col" class:required={Config.Required}>
			<div
				class="form-outline autocomplete"
				id="Street_Outline_{InstanceID}"
				bind:this={AutoCompleteEl}
			>
				<input
					class="form-control"
					id="street_{InstanceID}"
					type="text"
					name="street_{InstanceID}"
					required={Config.Required && !useOtherAddress}
					autocomplete="{autocompletePrefix}street-address"
					bind:this={StreetEl}
					class:is-invalid={(isInvalid || isStreetInvalid) && !useOtherAddress}
					class:is-valid={(isValid || isStreetValid) && !useOtherAddress}
					class:active={activeClass || (StreetEl?.value && StreetEl.value.length > 0)}
					on:input={(e) => {
						//Confirm that the value has changed
						//If not, don't do anything
						if (e.target?.value === inputVal) {
							return;
						}
						secondaryCheck(e);
						changeit();
						setAddressModified();
						inputVal = e.target?.value;
						// if (
						// 	!Config.AllowPOBox &&
						// 	POPrefixes.some((v) => inputVal.toLowerCase().startsWith(v))
						// ) {
						// 	setInvalid('Please enter a valid physical address');
						// }
						if (serverValidation) {
							serverValidation.valid = false;
						}
						if (!addressCheckRunning) {
							addressCheckComplete = false;
						}
					}}
					on:blur={(e) => {
						if (!is_focused) {
							//component was never focused, assume autocomplete or autofill
							validateBlurDebounced();
						}
						let valid_street = validateStreet(StreetEl.value);
						if (valid_street === true) {
							isStreetInvalid = false;
						} else {
							ErrorEl.innerHTML = valid_street;
							isStreetInvalid = true;
						}
					}}
					disabled={Disabled || useOtherAddress}
					readonly={ReadOnly}
				/>
				<label
					class="form-label"
					id="streetLbl_{InstanceID}"
					for="street_{InstanceID}"
					bind:this={StreetLabelEl}>Street</label
				>
				<div
					class="invalid-tooltip hidden"
					id="streetInfo_{InstanceID}"
					bind:this={ErrorEl}
					style:display={isStreetInvalid && !useOtherAddress ? 'block' : 'none'}
				/>
				<div class="msg-spacer" />
			</div>
		</div>
	</div>
	<div class="col-10 col-md-7">
		<div class="col form-outline">
			<input
				class="form-control"
				id="city_{InstanceID}"
				type="text"
				name="city_{InstanceID}"
				autocomplete="{autocompletePrefix}address-level2"
				bind:this={CityEl}
				class:is-invalid={(isInvalid && CityErrorEl.innerHTML) || isCityInvalid}
				class:is-valid={isValid || isCityValid}
				class:active={activeClass || cityVal.length > 0}
				on:input={() => {
					changeit();
					setAddressModified();
				}}
				on:blur={(e) => {
					if (!is_focused) {
						//component was never focused, assume autocomplete or autofill
						validateBlurDebounced();
					}
					let valid_city = validateCity(cityVal);
					if (valid_city === true) {
						CityErrorEl.style.display = 'none';
						isCityInvalid = false;
					} else {
						CityErrorEl.innerHTML = valid_city;
						CityErrorEl.style.display = 'block';
						isCityInvalid = true;
					}
				}}
				bind:value={cityVal}
				disabled={Disabled || useOtherAddress}
				readonly={ReadOnly}
			/>
			<div class="form-notch">
				<div class="form-notch-leading" style="width: 9px;" />
				<div class="form-notch-middle" style="width: 45.8px;" />
				<div class="form-notch-trailing" />
			</div>
			<label class="form-label" for="city_{InstanceID}">City</label>
			<div class="invalid-tooltip hidden" bind:this={CityErrorEl} />
			<div class="msg-spacer" />
		</div>
	</div>
	<div class="col-2 col-md-2">
		<div class="col form-outline">
			<input
				class="form-control"
				id="state_{InstanceID}"
				type="text"
				name="state_{InstanceID}"
				autocomplete="{autocompletePrefix}address-level1"
				bind:this={StateEl}
				class:is-invalid={(isInvalid && StateErrorEl.innerHTML) || isStateInvalid}
				class:is-valid={isValid || isStateValid}
				class:active={activeClass || stateVal.length > 0}
				on:input={() => {
					changeit();
					setAddressModified();
				}}
				on:blur={(e) => {
					if (!is_focused) {
						//component was never focused, assume autocomplete or autofill
						validateBlurDebounced();
					}
					//Change full names to abbreviations
					if (stateVal.length > 2) {
						Object.entries(states).forEach(([k, v]) => {
							if (v.full_name.toLowerCase() == stateVal.toLowerCase()) {
								stateVal = k;
							}
						});
					}
					let valid_state = validateState(stateVal);
					if (valid_state === true) {
						stateVal = stateVal.toUpperCase();
						StateErrorEl.style.display = 'none';
						isStateInvalid = false;
					} else {
						StateErrorEl.innerHTML = valid_state;
						StateErrorEl.style.display = 'block';
						isStateInvalid = true;
					}
				}}
				bind:value={stateVal}
				disabled={Disabled || useOtherAddress}
				readonly={ReadOnly}
			/>
			<label class="form-label" for="state_{InstanceID}">State</label>
			<div class="form-notch">
				<div class="form-notch-leading" style="width: 9px;" />
				<div class="form-notch-middle" style="width: 45.8px;" />
				<div class="form-notch-trailing" />
			</div>
			<div class="invalid-tooltip hidden" bind:this={StateErrorEl} />
			<div class="msg-spacer" />
		</div>
	</div>
	<div class="col-md-3 col-sm">
		<div class="col form-outline">
			<input
				class="form-control faded_placeholder"
				id="zipcode_{InstanceID}"
				type="text"
				name="zipcode_{InstanceID}"
				autocomplete="{autocompletePrefix}postal-code"
				bind:this={PostCodeEl}
				class:is-invalid={(isInvalid && ZipErrorEl.innerHTML) || isZipInvalid}
				class:is-valid={isValid || isZipValid}
				class:active={activeClass || zipVal.length > 0}
				on:input={() => {
					console.log('on:input called');
					changeit();
					setAddressModified();
				}}
				on:blur={(e) => {
					if (!is_focused) {
						//component was never focused, assume autocomplete or autofill
						validateBlurDebounced();
					}
					let valid_zip = validateZip(zipMaskHandler.getValue());
					if (valid_zip === true) {
						ZipErrorEl.style.display = 'none';
						isZipInvalid = false;
					} else {
						ZipErrorEl.innerHTML = valid_zip;
						ZipErrorEl.style.display = 'block';
						isZipInvalid = true;
					}
				}}
				bind:value={zipVal}
				disabled={Disabled || useOtherAddress}
				readonly={ReadOnly}
			/>
			<label class="form-label" for="zipcode_{InstanceID}">Zip Code</label>
			<div class="form-notch">
				<div class="form-notch-leading" style="width: 9px;" />
				<div class="form-notch-middle" style="width: 70.8px;" />
				<div class="form-notch-trailing" />
			</div>
			<div class="invalid-tooltip hidden" bind:this={ZipErrorEl} />
			<div class="msg-spacer" />
		</div>
	</div>
	<!-- <button class="btn btn-primary" on:click={() => {}}>Get Metadata</button> -->
	{#if ShowMetadata}
		<div class="col-12 border">
			<code class="json" style="font-size: 10px; white-space: pre-wrap;">{@html metacode_html}</code
			>
		</div>
		<div class="col-12 border">
			<code class="json" style="font-size: 10px; white-space: pre-wrap;"
				>{@html validatecode_html}</code
			>
		</div>
	{/if}
</FormGroup>
<Address_Select_Modal
	bind:this={address_select_modal}
	{selectEnteredAddress}
	{setSuggestedAddress}
/>

<style>
	.faded_placeholder::placeholder {
		opacity: 0.05;
	}

	.faded_placeholder::-webkit-input-placeholder {
		opacity: 0.05;
	}
	.faded_placeholder:-ms-input-placeholder {
		opacity: 0.05;
	}
	input.faded_placeholder::placeholder {
		opacity: 0.05;
	}
	:global(.spinner-border) {
		display: none !important;
	}
</style>
